import React from "react";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import Analytics from "../../../../helpers/analytics";

function GoToRiff(props) {
  const { jmId } = props;

  return (
    <div className="noRight jump-to-riff">
      <a
        onClick={() => {
          Analytics.track("Jump to Riff", {
            category: "LP-VideoDetail",
            label: jmId,
          });
        }}
        href={`${process.env.REACT_APP_RIFF_URL_NOCACHE}/video/edit/${jmId}`}
        className="back-text"
        target="_blank"
      >
        Jump to Riff Record
        <KeyboardArrowRightIcon />
      </a>
    </div>
  );
}

export default GoToRiff;
